module.exports = __webpack_public_path__ + "02_glasses_brown.0f9bdc73.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer4/02_glasses_brown.png
// module id = 6+iM
// module chunks = 0